module.exports = __webpack_public_path__ + "img/5.f0836966.png";